import { X, Clock } from "lucide-react";
import { toast } from "sonner";
import { cancelEntryOrder } from "@/lib/api";

const fmt = (v) => (v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const PendingEntryOrders = ({ orders, livePrices, onChanged }) => {
  if (!orders.length) return null;
  const cancel = async (o) => {
    try { await cancelEntryOrder(o.id); toast.success(`Cancelled auto-order for ${o.symbol}`); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't cancel"); }
  };
  return (
    <div className="bg-bt-surface border border-bt-border-subtle mb-4" data-testid="pending-entry-orders">
      <div className="flex items-center gap-2 px-4 py-2.5 border-b border-bt-border-subtle">
        <Clock className="w-3.5 h-3.5 text-bt-gold" />
        <span className="font-mono text-xs uppercase tracking-wider text-bt-text-secondary">Pending auto-buy orders</span>
        <span className="font-mono text-[10px] text-bt-text-tertiary ml-auto">{orders.length}</span>
      </div>
      {orders.map(o => {
        const live = livePrices[o.symbol] || o.price_at_create;
        const gap = live ? (o.trigger_price - live) / live * 100 : null;
        return (
          <div key={o.id} className="flex flex-wrap items-center gap-x-4 gap-y-1 px-4 py-2 border-b border-bt-border-subtle last:border-0 font-mono text-xs hover:bg-bt-hover transition-colors" data-testid={`entry-order-${o.symbol}`}>
            <span className="text-bt-text-primary font-medium w-16">{o.symbol}</span>
            <span className={o.position_type === "short" ? "text-bt-negative" : "text-bt-positive"}>{o.position_type === "short" ? "SHORT" : "BUY"} {o.shares}</span>
            <span className="text-bt-text-secondary">when {o.direction === "below" ? "≤" : "≥"} <span className="text-bt-gold">${fmt(o.trigger_price)}</span></span>
            {gap !== null && <span className="text-bt-text-tertiary">{Math.abs(gap).toFixed(1)}% {gap < 0 ? "below" : "above"} now</span>}
            {o.stop_pct && <span className="text-bt-negative">stop {o.stop_pct}%</span>}
            <span className="text-bt-text-tertiary">{o.expires_at ? `expires ${new Date(o.expires_at).toLocaleDateString()}` : "until cancelled"}</span>
            <button onClick={() => cancel(o)} className="ml-auto text-bt-text-tertiary hover:text-bt-negative transition-colors" title="Cancel order" data-testid={`cancel-entry-order-${o.symbol}`}>
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
